import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { SsoConfig } from '../../../../api/ApiTypes';
import { useDraft2 } from '../../../../CodesThatsGottaGoSomewhereElse';
import { Host } from '../../../../Host';
import { AccountModel } from '../../../account/AccountModel';
import { useResolve } from '../../../Container';

export const useSingleSignOnConstants = () => {
    const account = useResolve(AccountModel);
    const entityId = `${Host.baseUrl}/${account.id}`;
    const acsUrl = `${Host.baseUrl}/login/saml2?p=${account.id}`;
    return { entityId, acsUrl };
};

export const useSingleSignOnForm = () => {

    const form = useDraft2<Partial<SsoConfig>>({
        'entryPoint': '',
        'issuer': '',
        'certificate': '',
        'version': 'v2',
    });

    const [errors, setErrors] = useState({} as Record<string, boolean>);

    const checkErrors = useCallback(() => {
        const results = [
            ['entryPoint', !form.draft.entryPoint?.trim()],
            ['issuer', !form.draft.issuer?.trim()],
            ['certificate', !form.draft.certificate?.trim()],
        ];
        setErrors(Object.fromEntries(results));
        return !!results.find(x => !!x[1]);
    }, [form.draft]);

    return { ...form, errors, checkErrors };
};

export const useSingleSignOnQuery = () => {
    const api = useResolve(ApiClient);
    return useQuery({
        queryKey: ['admin.sso.info'],
        queryFn: async () => api.exec(v2.admin.sso.info()),
    });
};

export const useSingleSignOnMutation = () => {
    const api = useResolve(ApiClient);
    const qc = useQueryClient();
    return useMutation({
        mutationKey: ['admin.sso.save'],
        mutationFn: async (data: Partial<SsoConfig>) => api.exec(v2.admin.sso.save(data as SsoConfig)),
        onSettled: () => {
            qc.invalidateQueries(['admin.sso.info']);
        },
    });
};
